import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { chatbotService } from '../../../services/ChatbotService';
import { chatbotQueryKeys } from '../chatbotQueryKeys';

export function useChatbotTrainingExampleQuery(
  chatbotId: string | undefined,
  exampleId: string | undefined,
  enabled = true,
) {
  const { user } = useAuth();
  const resolvedChatbotId = chatbotId?.trim() ?? '';
  const resolvedExampleId = exampleId?.trim() ?? '';
  const isEnabled =
    enabled &&
    Boolean(user) &&
    resolvedChatbotId.length > 0 &&
    resolvedExampleId.length > 0;

  return useQuery({
    queryKey: chatbotQueryKeys.trainingExample(
      resolvedChatbotId,
      resolvedExampleId,
    ),
    enabled: isEnabled,
    queryFn: () =>
      chatbotService.readTrainingExample(resolvedChatbotId, resolvedExampleId),
  });
}
